import { Badge } from "~/components/ui/badge";
import { cn } from "~/lib/utils";

interface ApprovalStatusBadgeProps {
  status: string;
  className?: string;
}

const STATUS_STYLES: Record<string, { label: string; className: string }> = {
  pending: {
    label: "Pendiente",
    className: "border-amber-200 bg-amber-100 text-amber-800",
  },
  approved: {
    label: "Aprobado",
    className: "border-green-200 bg-green-100 text-green-800",
  },
  rejected: {
    label: "Rechazado",
    className: "border-red-200 bg-red-100 text-red-800",
  },
};

export function ApprovalStatusBadge({
  status,
  className,
}: ApprovalStatusBadgeProps) {
  const style = STATUS_STYLES[status] ?? {
    label: status,
    className: "border-gray-200 bg-gray-100 text-gray-800",
  };

  return (
    <Badge className={cn(style.className, className)}>{style.label}</Badge>
  );
}
